import SideBar from "./Component/sidebar/sidebar";
import {Routes, Route, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import Login from "./Component/login/login";
import Users from "./pages/Users/Users";
import Header from "./Component/header/Header";
import Product from "./pages/Product/myProduct/Product";
import Category from "./pages/Category/Category";
import {Toaster} from "react-hot-toast";
import ProductDetails from "./pages/Product/myProduct/ProductDetaills";
import ProductCreate from "./pages/Product/myProduct/ProductCreate";
import MyProfile from "./pages/Setting/MyProfile";
import MultiBanner from "./pages/SiteBanner/MultiBanner";
import CategoryCreate from "./pages/Category/CategoryCreate";
import UserDetails from "./pages/Users/UserDetails";
import Dashboard from "./pages/Dashboard/Dashboard";
import Comment from "./pages/Comment/Comment";
import {Info} from "lucide-react";
import Invoice from "./pages/Invoice/Invoice";
import InvoiceDetails from "./pages/Invoice/InvoiceDetails";
import PaymentMethod from "./pages/PaymentMethod/PaymentMethod";
import MainBanner from "./pages/SiteBanner/AllBanners";
import Admins from "./pages/Admins/admins";
import SpecialOffers from "./pages/Advertisement/SpecialOffers/SpecialOffers";
import Wonderful from "./pages/Advertisement/WonderfulOffers/Wonderful";
import AddToOffers from "./pages/Advertisement/SpecialOffers/AddToOffers";
import AddToWonderful from "./pages/Advertisement/WonderfulOffers/AddToWonderful";
import CreateBanner from "./pages/SiteBanner/CreateBanner";
import EditBanners from "./pages/SiteBanner/EditBanners";


function App() {

    const location = useLocation();
    const navigate = useNavigate();
    const [accessToken, setAccessToken] = useState(localStorage.getItem("accessToken"));

    useEffect(() => {
        if (!accessToken) {
            navigate("/");
        }
    }, []);


    return (
        <>
            <Toaster position="top-left"/>
            {accessToken ?
                <div className="grid grid-cols-10">

                    <div className="col-span-2 md:hidden bg-secondColor-shade7 rounded-r-md min-h-screen h-full">
                        <SideBar/>
                    </div>

                    <div className="col-span-8 md:col-span-10 max-h-screen overflow-y-scroll">

                        <Header/>

                        <Routes>
                            <Route path={"/all-banner"} element={<MainBanner/>}/>
                            <Route path={"/Multi-banner"} element={<MultiBanner/>}/>
                            <Route path={"/Create-banner"} element={<CreateBanner/>}/>
                            <Route path={"/all-banner/edit-Banners"} element={<EditBanners/>}/>
                            <Route path={"/"} element={<Dashboard/>}/>
                            <Route path={"/user"} element={<Users/>}/>
                            <Route path={"/user/:id"} element={<UserDetails/>}/>
                            <Route path={"/my-product"} element={<Product/>}/>
                            <Route path={"/product/:id"} element={<ProductDetails/>}/>
                            <Route path={"/product/create"} element={<ProductCreate/>}/>
                            <Route path={"/category"} element={<Category/>}/>
                            <Route path={"/category/create"} element={<CategoryCreate/>}/>
                            <Route path={"/comment"} element={<Comment/>}/>
                            <Route path={"/invoice"} element={<Invoice/>}/>
                            <Route path={"/invoice/details/:id"} element={<InvoiceDetails/>}/>
                            <Route path={"/payment-methode"} element={<PaymentMethod/>}/>
                            <Route path={"/setting"} element={<MyProfile/>}/>
                            <Route path={"/admins"} element={<Admins/>}/>
                            <Route path={"/offerManagement"} element={<SpecialOffers/>}/>
                            <Route path={"/offerManagement/add"} element={<AddToOffers/>}/>
                            <Route path={"/wonderfulManagement"} element={<Wonderful/>}/>
                            <Route path={"/wonderfulManagement/add"} element={<AddToWonderful/>}/>
                        </Routes>

                    </div>
                </div>
                :
                <Routes>
                    <Route path={"/"} element={<Login/>}/>
                </Routes>
            }
        </>
    );
}


export default App;
